module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/084-barbados-5e8c778d2a64de8baa0366d86353ffc5.svg";